import { isCommitmentAccount } from "./isCommitmentAccount";
import { CoverageGroupResponse } from "@/services/cloudchipr.api";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";
import { commitmentsColors } from "@/utils/constants/commitmentsColors";

type CoverageHighChartsData = {
  costBased: HighchartsChartDataType;
  percentBased: HighchartsChartDataType;
};

export const generateHighChartsDataFromCoverage = (
  data?: CoverageGroupResponse[],
): CoverageHighChartsData => {
  const categories =
    data?.map(
      (group) =>
        (isCommitmentAccount(group.name) ? group?.name?.name : group?.name) ??
        "",
    ) ?? [];
  const costData = [
    {
      name: "SP",
      color: commitmentsColors.sp,
      data:
        data?.map((group) => ({ y: group?.savings_plan?.amount ?? 0 })) ?? [],
    },
    {
      name: "RI",
      color: commitmentsColors.ri,
      data:
        data?.map((group) => ({ y: group?.reservation?.amount ?? 0 })) ?? [],
    },
    {
      name: "On-Demand",
      color: commitmentsColors.onDemand,
      data: data?.map((group) => ({ y: group?.on_demand?.amount ?? 0 })) ?? [],
    },
  ];

  const percentData = [
    {
      name: "SP",
      color: commitmentsColors.sp,
      data:
        data?.map((group) => ({ y: group?.savings_plan?.percentage ?? 0 })) ??
        [],
    },
    {
      name: "RI",
      color: commitmentsColors.ri,
      data:
        data?.map((group) => ({ y: group?.reservation?.percentage ?? 0 })) ??
        [],
    },
    {
      name: "On-Demand",
      color: commitmentsColors.onDemand,
      data:
        data?.map((group) => ({ y: group?.on_demand?.percentage ?? 0 })) ?? [],
    },
  ];

  return {
    costBased: {
      categories,
      series: costData,
    },
    percentBased: {
      categories,
      series: percentData,
    },
  };
};
